class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.sticky-add-to-cart__button');
    this.targetButtonId = this.dataset.targetButton;
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.ticking = false;
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.onButtonClick);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    // Run once on load in case the page opens already scrolled.
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    this.button?.removeEventListener('click', this.onButtonClick);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      const target = document.getElementById(this.targetButtonId);
      if (target) {
        const rect = target.getBoundingClientRect();
        // Show once the target button's bottom edge has scrolled above the viewport.
        const shouldShow = rect.bottom < 0;
        this.classList.toggle('is-visible', shouldShow);
      }
      this.ticking = false;
    });
  }

  onButtonClick() {
    const originalButton = document.getElementById(this.targetButtonId);
    if (originalButton && !originalButton.disabled) {
      originalButton.click();
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
